module.exports = __webpack_public_path__ + "static/media/sample_manage_trucks.1d8cbadc.csv";